module.exports = __webpack_public_path__ + "static/total_premium.5b0d3cac.svg";